import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import Container from './Container';


const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

const SupportTemplate = ({
  className,
  classes,
}) => {
  const theme = useTheme();
  useBackgroundColor(theme.palette.facet.lightGray);
  const { pageContentResource } = usePageContentContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <IncludedRelationshipProvider
        relationship={pageContentResource.relationship(fr.relationships.membership.name)}
      >
        <Container />
      </IncludedRelationshipProvider>
    </Box>
  );
};

SupportTemplate.defaultProps = {
  className: '',
};

SupportTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SupportTemplate);
